import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CreateTimecardComponent} from './createtimecard/createtimecard.component';
import {RecentTimecardsComponent} from './recenttimecard/recenttimecards.component';
import {SysadminComponent} from './sysadmin/sysadmin.component';
import {HomeComponent} from './home/home.component';
import {ReportsComponent} from './reports/reports.component';
import {SystemUnavailComponent} from './systemunavail/systemunavail.component';
import {PendingChangesGuard} from './services/pendingchanges.guard';
import {MsalGuard} from '@azure/msal-angular';
import {GroupGuardService} from './services/group-guard.service';
import {AccessDeniedComponent} from './access-denied/access-denied.component';
import {ErrorComponent} from './error/error.component';

const routes: Routes = [
  {
    path: 'createtimecard',
    component: CreateTimecardComponent,
    canDeactivate: [PendingChangesGuard],
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    path: 'recenttimecards',
    component: RecentTimecardsComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    path: 'sysadmin',
    component: SysadminComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [
      MsalGuard,
      GroupGuardService
    ]
  },
  {
    path: 'systemunavail',
    component: SystemUnavailComponent
  },

  {
    path: 'accessdenied',
    component: AccessDeniedComponent
  },
  {
    // Needed for hash routing
    path: 'state',
    component: ErrorComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    // Needed for hash routing
    path: 'code',
    component: ErrorComponent
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
